import styled, { createGlobalStyle } from "styled-components";
import {
  AlertContentGrid,
  XIconWrapper,
} from "@/components/generic/Alert/Alert.styled";
import { PageContainer, PageContent } from "@/components/generic/PageLayout";
import { NARROW_SCREEN } from "@/constants/layout";

/**
 * StableScrollbarGutter
 *
 * Holds the document's scrollbar gutter open while this page is mounted. A
 * scrollbar appearing takes ~13.5px out of the search field, the row's only
 * flexible item, so results crossing the window height resized the search bar
 * as they landed (WCHK-3037).
 */
export const StableScrollbarGutter = createGlobalStyle`
  html {
    scrollbar-gutter: stable;
  }
  @supports not (scrollbar-gutter: stable) {
    html {
      overflow-y: scroll;
    }
  }
`;

export const SearchPageContainer = PageContainer;

export const SearchPageContent = PageContent;

export const InlineAlertScope = styled.div`
  width: 100%;
  margin-bottom: 16px;
  & ${AlertContentGrid} {
    margin-left: 0;
    margin-right: 0;
  }
  & ${XIconWrapper} {
    margin-top: 16px;
    margin-right: 16px;
  }
`;

export const NaturalLanguageSearchPageContent = SearchPageContent;

// Same column as the page content, so the beta banners line up with it.
export const BetaAnnouncementRow = SearchPageContent;

export { NARROW_SCREEN };

/**
 * SearchRow
 *
 * Holds the search field and the filters toggle side by side. On a narrow
 * screen one row runs them into each other, so they stack (WCHK-3048 review).
 */
export const SearchRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  ${NARROW_SCREEN} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchFieldSlot = styled.div`
  flex: 1;
  min-width: 0;
`;

/**
 * DateFilterSlot
 *
 * Holds the date range filter immediately right of the search field, outside
 * the filters group, so the range in force is visible whether or not the
 * filters are expanded (WCHK-3083).
 *
 * Layout only. The pill's own box comes from its `size="large"` variant, which
 * FilterPill enumerates (WCHK-3083 review). Stacked, the pill's inline-block
 * root has to become a block before it can fill the column.
 *
 * `$dimmed` matches the filters container while a round trip runs: the range
 * is still shown, dimmed to say it is frozen (WCHK-3037).
 */
export const DateFilterSlot = styled.div`
  flex-shrink: 0;
  ${({ $dimmed }) => ($dimmed ? "opacity: 0.6;" : "")}
  ${NARROW_SCREEN} {
    & > div {
      display: block;
      width: 100%;
    }
  }
`;
